import { Typography } from '@material-ui/core'
import { Box, Tooltip } from '@mui/material'
import React from 'react'
import { IoIosInformationCircleOutline } from 'react-icons/io'

export interface ITooltipIconProps {
  tooltip: string
}

export default function TooltipIcon({ tooltip }: ITooltipIconProps) {
  return (
    <Tooltip title={<Typography variant="subtitle1">{tooltip}</Typography>}>
      <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '24px', color: 'tooltip', fontWeight: 'normal' }}>
        <IoIosInformationCircleOutline />
      </Box>
    </Tooltip>
  )
}
